/**
 * Deep-link restoration across the login round-trip. The key is shared with
 * 404.html (SPA fallback), which stashes the original path on hard loads;
 * pages that bounce an unauthenticated user to /login stash here too, and the
 * sign-in flow consumes it as the post-login destination.
 */

const KEY = 'bizguard_intended_route';

export function stashIntendedRoute(path: string): void {
  sessionStorage.setItem(KEY, path);
}

export function peekIntendedRoute(): string | null {
  return sessionStorage.getItem(KEY);
}

export function consumeIntendedRoute(): string | null {
  const path = sessionStorage.getItem(KEY);
  if (path) sessionStorage.removeItem(KEY);
  return path;
}
